/* @ngInject */
function AdvancedSearchDropdownController ($scope, $rootScope, $timeout, $state, $attrs, RepositoryService) {
  let inputTimer = null
  let tagsInputTimer = null
  $scope.pricing = {
    organized: {
      access: false
    }
  }
  $scope.tagsResults = []
  $scope.assetResults = []

  $scope.tagSearch = $scope.tagSearch || ''
  $scope.selectedTags = $scope.selectedTags || []

  $scope.flags = {
    top: 6,
    skip: 0,
    tagsTop: 10,
    hasMoreAssets: true,
    loadingAssets: false,
    noAssetsResults: false,
    noTagsResults: false
  }

  const api = {
    _getTagsResults,
    _isTagSelected,
    _handleAssetsResponse,
    _handleTagsResponse,
    _handleGetMoreAssets,
    _getAssetsResults,
    _initializeAssetsInfiniteScroll,
    _verifyIntersectionButton,
    _handleInfiniteScroll,
    _handleLoadFlags,
    _handlePricing
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getTagsResults()
    api._handlePricing()

    $timeout(() => {
      api._initializeAssetsInfiniteScroll()
    }, 1000, true)
  }

  $scope.$watch('isOpen', () => {
    if ($scope.isOpen) {
      api._getTagsResults()
    }
  })

  $scope.$watch('search', () => {
    if (inputTimer) {
      $timeout.cancel(inputTimer)
    }

    inputTimer = $timeout(() => {
      $scope.flags.loadingAssets = true
      $scope.flags.skip = 0
      $scope.assetResults = []

      api._getAssetsResults()
    }, 300)
  })

  function _getAssetsResults (type) {
    const folderId = $state.current.name.includes('Folder') && $state.params.id ? Number($state.params.id) : null
    $scope.flags.loadingAssets = true

    if (!$scope.pricing.organized.access) {
      return RepositoryService.getAllAssets({
        $top: $scope.flags.top,
        $skip: $scope.flags.skip,
        search: $scope.search,
        $sort: 'relevance',
        $order: 'DESC',
        organized: $state.current.name.includes('organized')
      }, folderId).then((assetsResponse) => {
        if (type === 'infinite') {
          api._handleGetMoreAssets(assetsResponse)
          return
        }

        api._handleAssetsResponse(assetsResponse)
      })
    }

    return RepositoryService.searchOrganized({
      $top: $scope.flags.top,
      $skip: $scope.flags.skip,
      $sort: 'relevance',
      $order: 'DESC',
      search: $scope.search,
      folderId
    }).then((assetsResponse) => {
      if (type === 'infinite') {
        return api._handleGetMoreAssets(assetsResponse)
      }

      api._handleAssetsResponse(assetsResponse)
    })
  }

  function _handleAssetsResponse ({ rows, count }) {
    $scope.assetResults = rows
    api._handleLoadFlags(count)
  }

  function _handleGetMoreAssets ({ rows, count }) {
    $scope.assetResults.push(...rows)
    api._handleLoadFlags(count)
  }

  function _handleLoadFlags (count) {
    $timeout(() => {
      $scope.flags.loadingAssets = false
      $scope.flags.skip = $scope.flags.skip + $scope.flags.top
      $scope.flags.hasMoreAssets = $scope.assetResults.length < count
      $scope.flags.noAssetsResults = !$scope.assetResults.length
    }, 0, true)
  }

  function _getTagsResults () {
    RepositoryService.getAllAssetTags(
      { top: $scope.flags.tagsTop },
      $scope.tagSearch
    ).then(api._handleTagsResponse)
  }

  $scope.handleTagsInput = () => {
    if (tagsInputTimer) {
      $timeout.cancel(tagsInputTimer)
    }

    tagsInputTimer = $timeout(() => {
      api._getTagsResults()
    }, 300)
  }

  function _handleTagsResponse ({ rows }) {
    $scope.flags.loadingTags = false
    $scope.tagsResults = rows

    $scope.flags.noTagsResults = !$scope.tagsResults.length
  }

  $scope.onSubmitClick = () => {
    $scope.onSubmit()
    $scope.isOpen = false
  }

  $scope.handleAssetClick = (asset) => {
    $scope.onAssetClick(asset)
    $scope.isOpen = false
  }

  $scope.handleTagClickRemove = (tag) => {
    $timeout(() => {
      const tagIndex = $scope.selectedTags.findIndex((selectedTag) => selectedTag.id !== tag.id)
      $scope.selectedTags.splice(tagIndex, 1)
    }, 0, true)
  }

  $scope.handleTagClickAdd = (tag) => {
    $timeout(() => {
      $scope.selectedTags.push(tag)
    }, 0, true)
  }

  $scope.getTagType = (tag) => {
    return api._isTagSelected(tag) ? 'clear' : 'add'
  }

  function _isTagSelected (tag) {
    return $scope.selectedTags.some((selectedTag) => tag.id === selectedTag.id)
  }
  $scope.isTagSelected = api._isTagSelected

  $scope.getAssetResultIcon = (asset) => {
    if (asset.cardType === 'folder') return 'dam'

    const resultType = asset.type
    const audioTypes = ['AUDIO']
    const designTypes = ['ILLUSTRATOR', 'PHOTOSHOP']
    const videoTypes = ['VIDEO']
    const imageTypes = ['IMAGE', 'ART']

    if (audioTypes.includes(resultType)) return 'headphones'
    if (designTypes.includes(resultType)) return 'pen-tool'
    if (videoTypes.includes(resultType)) return 'play'
    if (imageTypes.includes(resultType)) return 'image'

    return 'file-text'
  }

  function _initializeAssetsInfiniteScroll () {
    const showMoreButton = $attrs.$$element.find('#infinite-scroll-spinner')[0]

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4
    }

    const observer = new IntersectionObserver(api._verifyIntersectionButton, options)

    if (showMoreButton) {
      observer.observe(showMoreButton)
    }
  }

  function _verifyIntersectionButton ([entry]) {
    if (entry.isIntersecting && entry.intersectionRatio >= 0.4 && $scope.flags.hasMoreAssets) {
      api._handleInfiniteScroll()
    }
  }

  function _handleInfiniteScroll () {
    if (!$scope.flags.loadingAssets) {
      $scope.flags.loadingAssets = true
      api._getAssetsResults('infinite')
    }
  }

  function _handlePricing () {
    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      const hasOrganized = !!features['REPOSITORIES.ORGANIZED']
      $scope.pricing.organized.access = hasOrganized
    })
  }

  $scope.handleLoadMoreButton = (ev) => {
    ev.stopPropagation()
    api._handleInfiniteScroll()
  }
}

export { AdvancedSearchDropdownController }
